import { FieldTypeOption } from "@kaltura/mediaspace-shared-types";
import { Template } from "@kaltura/mediaspace-shared-ui/controlled-form";

/**
 * Room availability options
 */
export enum ScheduleOptions {
    ALWAYS = "always",
    SCHEDULED = "scheduled",
}

export type FormOptions = {
    templates: Template[];
    timezones: FieldTypeOption[];
};
